import { Component, OnInit } from '@angular/core';
import { AsyncLocalStorage } from 'angular-async-local-storage';
import { Router } from '@angular/router';

@Component({
	selector: 'app-submenu',
	templateUrl: './submenu.component.html',
    styleUrls: ['./submenu.component.css'],
})
export class SubmenuComponent implements OnInit {
    public loading: boolean;
    public children: Array<any>;
    public transacciones: Array<any>;
    public consultas: Array<any>;

	constructor(
        private storage: AsyncLocalStorage,
        private NavRoute: Router,
    ) {
        this.loading = false;
        this.children = [];
        this.transacciones = [];
        this.consultas = [];
    }

	ngOnInit(){
        this.loading = true;
        this.storage.getItem('menu').subscribe(
            menu => {
                this.children = menu.children;
                this.transacciones = menu.transacciones;
                this.consultas = menu.consultas;
                
                this.loading = false;
            }
        );
    }

    openSubmenu(submenu){
        this.NavRoute.navigate([submenu.path]);
    }
}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/desktop/submenu/submenu.component.ts